import { Skeleton } from "@mui/material";

export const ActionCardSkeleton = () => {
  return <Skeleton sx={{ mx: 8 }} height={56} />;
};
